import { StyledNotFound } from './notfound-style';
import { Button } from '../../components/button/Button';
import { useNavigate } from 'react-router-dom';
import { Spacer } from '../../components/Spacer';
import { getLocalizedPath } from '../../utils/lang';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <>
      <StyledNotFound>
        <h1>Ops, page not found</h1>
        <p>The requested page does not exist.</p>
        <Spacer />
        <Button onClick={() => navigate(getLocalizedPath('/'))}>Back to Home</Button>
      </StyledNotFound>
    </>
  );
};

export default NotFound;
